import { getMapsClickout } from '../../../../../../utils/getMapsClickout';
import { useExperimentFlag } from '../../../../../../utils/useExperimentFlag';
import { PostUI } from '../../../../types';

export const useCardActionsFlags = (post: PostUI) => {
    const isViewsBadgeEnabled = Number(useExperimentFlag('show_views_badge')) === 1;
    const isCheckoutExpOn = Number(useExperimentFlag('products_checkout')) === 2;

    const hasDikidiBookingBadge = Boolean(post.business?.isDikidiApproved);
    const hasMapsBookingBadge = Boolean(getMapsClickout(post.clickouts)?.url);
    const hasBookingBadge = hasDikidiBookingBadge || hasMapsBookingBadge;

    const hasCheckoutUrl = post.products?.items?.some((product) => product.checkout?.url);
    const withCheckout = isCheckoutExpOn && hasCheckoutUrl && !hasBookingBadge;
    const hasViewsBadge = !withCheckout && isViewsBadgeEnabled && Boolean(post.publicStats?.shows);

    return { withCheckout, hasBookingBadge, hasViewsBadge };
};
